import styled from "styled-components";

export const Wrapper: any = styled.div`
  position: relative;
  flex: 1 1 100%;
  display: ${({ active }: { active: boolean }) => (active ? "block" : "none")};
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
  padding: 2em 2em 0;
`;
